import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bot, Globe, KeyRound, MessageSquare } from 'lucide-react';

const STEPS = [
  { key: 'create', Icon: Bot },
  { key: 'embed', Icon: Globe },
  { key: 'api', Icon: KeyRound },
  { key: 'channels', Icon: MessageSquare },
] as const;

export const PublishSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-[#101827] text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold uppercase text-amber-200">
            {t('landing.publish.eyebrow')}
          </p>
          <h2 className="mt-3 text-3xl font-bold leading-tight md:text-4xl">
            {t('landing.publish.title')}
          </h2>
          <p className="mt-4 text-base leading-7 text-slate-300">
            {t('landing.publish.description')}
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-4">
          {STEPS.map(({ key, Icon }) => (
            <article key={key} className="rounded-lg border border-white/10 bg-white/[0.04] p-5">
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-amber-300/15 text-amber-200">
                <Icon size={20} />
              </div>
              <h3 className="font-semibold">{t(`landing.publish.steps.${key}.label`)}</h3>
              <p className="mt-3 text-sm leading-6 text-slate-300">
                {t(`landing.publish.steps.${key}.detail`)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
